<div class="white-overlay">
  <div class="loading-container ion-text-center">
   <object type="image/svg+xml" data="assets/images/Ready-spinner.svg" width=150px></object>
  </div>
</div>
